import { IColumn, IProductionAggregate } from "../../../../types";
import TableContainer from "../../../../components/tableContainer";
import { Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import StyledTableRow from "../../../../components/styledTableRow";
import { ReactElement } from "react";

interface IProps {
  data: IProductionAggregate[];
}

const columns: IColumn[] = [
  {
    id: "variable",
    label: "Variable",
    minWidth: 300,
  },
  {
    id: "unit",
    label: "Unit",
    minWidth: 100,
    align: "center"
  },
  {
    id: "min",
    label: "Minimum",
    minWidth: 200,
    align: "right",
  },
  {
    id: "max",
    label: "Maximum",
    minWidth: 200,
    align: "right",
  },
  {
    id: "avg",
    label: "Average",
    minWidth: 200,
    align: "right",
  },
  {
    id: "desStd",
    label: "Standard Deviation",
    minWidth: 200,
    align: "right",
  }
];

export const RoundQualityPanel = ({ data }: IProps): ReactElement => {

  return (
    <TableContainer>
      <Table stickyHeader={true} size={"small"} >
        <TableHead>
          <TableRow>
            {columns.map((column) =>
              <TableCell
                className="table-header"
                key={column.id}
                align={column.align}
                style={{ minWidth: column.minWidth, width: column.minWidth }}>
                {column.label}
              </TableCell>
            )}
            <TableCell className="table-header"/>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row, index) => {
            return (
              <StyledTableRow hover={true} role="checkbox" tabIndex={-1} key={`temp-row-${index}`}>
                {columns.map((column: IColumn) => {

                  if (column.id === "unit") {

                    return (
                      <TableCell key={column.id} align={column.align}>
                        {row.axis.unit}
                      </TableCell>
                    );
                  }

                  const value = row[column.id as keyof Omit<IProductionAggregate, "axis">];

                  return (
                    <TableCell key={column.id} align={column.align}>
                      {column.format && typeof value === "number" ? column.format(value) : value}
                    </TableCell>
                  );
                })}
                <TableCell/>
              </StyledTableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default RoundQualityPanel;
